import { gql } from '@apollo/client'
export const GET_ALL_EMPLOYEES = gql`
  query GetAllEmployees(
    $searchQuery: String
    $limit: Int
    $offset: Int
    $filters: filtersEmployees
  ) {
    getAllEmployees(
      searchQuery: $searchQuery
      limit: $limit
      offset: $offset
      filters: $filters
    ) {
      count
      rows {
        id
        first_name
        last_name
        photo_url
        email
        phone
        area_id
        job_position_id
        schedule_group_id
        is_active
        is_disabled
        disabled_at
        EmployeeToDocuments {
          file_url
        }
        EmployeeToScheduleGroup {
          id
          name
        }
        EmployeeToJobPosition {
          id
          name
        }
        EmployeeToLogsEmployee {
          id
        }
      }
    }
  }
`

export const GET_EMPLOYEE_BY_ID = gql`
  query GetEmployeeById($getEmployeeByIdId: Int!) {
    getEmployeeById(id: $getEmployeeByIdId) {
      id
      first_name
      last_name
      photo_url
      email
      phone
      area_id
      job_position_id
      schedule_group_id
      is_active
      is_disabled
      disabled_at
      EmployeeToDocuments {
        id
        file_url
        name
      }
      EmployeeToScheduleGroup {
        id
        name
      }
      EmployeeToJobPosition {
        id
        name
      }
    }
  }
`

export const CREATE_EMPLOYEE = gql`
  mutation CreateEmployee($input: EmployeesInput!) {
    createEmployee(input: $input)
  }
`

export const UPDATE_EMPLOYEE = gql`
  mutation UpdateEmployee($updateEmployeeId: Int!, $input: EmployeesInput!) {
    updateEmployee(id: $updateEmployeeId, input: $input)
  }
`
